import { emptyAddress, formatAddress } from "./address";
import { CLAIM_TYPE_CODES, toFaultTypeCode } from "./options";

function toBoolean(value) {
  return value === "Yes";
}

/*
Form values -> submit body for POST /ticket/public-create/.

The delivery address collapses onto the address "above" when "same as above"
is ticked: the customer's own address for a customer, or the retailer/pickup
address for a retailer. When unticked, the separate delivery address is sent.
Either way the top-level structured fields carry it and `delivery_address` is
the same address as one line (as is `pickup_address` for the retailer's
address). The customer's structured address is only collected when a customer
lodges the request; fields a customer is never shown (retailer contact
details, Solvup case) are sent empty
so stale values from switching don't leak.
*/
export function toCreateRequestDto(values, attachmentTokens) {
  const isCustomer = values.submitterType === "customer";
  const retailerAddress = isCustomer ? emptyAddress() : values.retailerAddress;
  const aboveAddress = isCustomer ? values.customerAddress : retailerAddress;
  const delivery = values.deliverySameAsAbove ? aboveAddress : values.deliveryAddress;
  const customerAddress = isCustomer ? values.customerAddress : emptyAddress();

  const reason =
    values.claimType === "Other" && values.claimTypeOther
      ? `${values.claimTypeOther}. ${values.faultDescription}`.trim()
      : values.faultDescription;

  return {
    brand_id: values.brandId ? Number(values.brandId) : 0,
    claim_type: CLAIM_TYPE_CODES[values.claimType],
    fault_types: values.faults.map(toFaultTypeCode),
    reason,
    fault_replicated_in_store: toBoolean(values.replicatedInStore),
    replication_steps: values.replicationSteps,
    cosmetic_condition: values.cosmeticCondition,
    cosmetic_condition_other:
      values.cosmeticCondition === "other" ? values.cosmeticConditionOther.trim() : "",
    water_debris_removed: toBoolean(values.waterAndDebrisRemoved),
    missing_accessories: values.missingAccessories,
    terms_accepted: values.agreed,
    primary_email: isCustomer ? "customer" : values.primaryEmail,
    retailer_phone: isCustomer ? "" : values.retailerPhone,
    retailer_email: isCustomer ? "" : values.retailerEmail,
    pickup_address: formatAddress(retailerAddress),
    delivery_address: formatAddress(delivery),
    address_line_one: delivery.lineOne,
    address_line_two: delivery.lineTwo,
    suburb: delivery.suburb,
    postcode: delivery.postcode,
    state: delivery.state,
    solvup_id: isCustomer ? "" : values.solvupCase,
    attachment_tokens: attachmentTokens,
    customer: {
      email: values.customerEmail,
      first_name: values.customerFirstName,
      last_name: values.customerLastName,
      mobile: values.customerPhone,
      address_line_one: customerAddress.lineOne,
      address_line_two: customerAddress.lineTwo,
      suburb: customerAddress.suburb,
      postcode: customerAddress.postcode,
      state: customerAddress.state,
    },
    user_device: {
      device_id: values.deviceId ? Number(values.deviceId) : 0,
      serial_number: values.serialNumber,
      date_of_purchase: values.popDate,
      seller_details: values.retailer,
      store_location: values.store,
      store_reference: isCustomer ? "" : values.storeReference,
    },
  };
}
